// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3AIdy","tab":"ProcedureTabs_tab__Gdzeo"};